import { breakpoints } from '@configs/breakpoints';
import {
  Box,
  px2rem,
  colors,
  ContentText,
  Heading,
  Button,
  SidebarItem,
  IconCross,
  SidebarItemGroup,
  // Link,
} from '@fortum/elemental-ui';
import styled from 'styled-components';

export const StyledHeader = styled(Box)`
  height: ${px2rem(64)};
  max-height: ${px2rem(80)};
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  padding-left: ${px2rem(16)};
  padding-right: ${px2rem(40)};
  align-items: center;
  background-color: ${colors.snowWhite};
  border-bottom: 1px solid ${colors.silverGrey};
  box-sizing: border-box;

  @media screen and (max-width: ${breakpoints.mobile}) {
    padding-right: ${px2rem(16)};
  }

  @media screen and (max-width: ${breakpoints.large}) {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
  }
`;

export const DesktopHeaderShell = styled.div`
  width: 100%;
`;

export const DesktopTopRow = styled(Box)`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  min-height: ${px2rem(48)};
  padding: 0 ${px2rem(40)};
  background-color: ${colors.snowWhite};
  border-bottom: 1px solid ${colors.mistGrey};
  box-sizing: border-box;
`;

export const DesktopTopRowActions = styled.div`
  display: flex;
  align-items: center;
`;

export const DesktopSecondRow = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  min-height: ${px2rem(72)};
  padding: 0 ${px2rem(40)};
  background-color: ${colors.ivyGreen900};
  box-sizing: border-box;
`;

export const DesktopBrandContainer = styled.div`
  display: flex;
  align-items: center;
  // column-gap: ${px2rem(20)};
`;

export const DesktopSeparator = styled.div`
  width: 1px;
  height: ${px2rem(24)};
  background-color: ${colors.poweringGreen500};
`;

export const DesktopBrandText = styled(Heading)`
  color: ${colors.snowWhite};
  font-size: ${px2rem(23)} !important;
  line-height: 1;
  margin-left: ${px2rem(16)};
`;

export const DesktopNavigation = styled.div`
  display: flex;
  align-items: stretch;
  height: 100%;
`;

export const DesktopNavButton = styled(Button)<{ $active: boolean }>`
  height: 100%;
  min-height: ${px2rem(72)};
  border-radius: 0;
  padding: 0 ${px2rem(24)};
  background-color: ${({ $active }) =>
    $active ? colors.ivyGreen600 : 'transparent'} !important;
  box-shadow: none !important;

  &:hover {
    background-color: ${({ $active }) =>
      $active ? colors.ivyGreen600 : '#08241a'} !important;
  }

  &:focus-visible {
    background-color: ${({ $active }) =>
      $active ? colors.ivyGreen600 : colors.ivyGreen600} !important;
  }
`;

export const LogoContainer = styled(Box)`
  display: flex;
  align-items: center;
`;

export const MobileBrandContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const TabletLogoLink = styled.div`
  margin-right: 1rem;
`;

export const MobileLogoLink = styled.div`
  margin-right: 0.25rem;
`;

export const MobileSeparator = styled.div`
  width: 2px;
  height: ${px2rem(20)};
  background-color: ${colors.ivyGreen600};
`;

export const TabletSeparator = styled.div`
  width: 2px;
  height: ${px2rem(24)};
  background-color: ${colors.ivyGreen600};
`;

export const MobileBrandText = styled(Heading)`
  color: ${colors.inkGrey};
  font-size: ${px2rem(18)} !important;
  line-height: 1;
  margin-left: ${px2rem(8)};
`;

export const TabletBrandText = styled(Heading)`
  color: ${colors.inkGrey};
  font-size: ${px2rem(23)} !important;
  // line-height: 1;
  margin-left: ${px2rem(16)};
`;

export const HeaderSidebar = styled(Box)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const ContainerSidebar = styled(Box)`
  display: none;
  cursor: pointer;

  @media screen and (max-width: ${breakpoints.large}) {
    display: block;
  }
`;

export const CloseIconButton = styled(IconCross)`
  cursor: pointer;
`;

export const FlexLogoContainer = styled(Box)`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  column-gap: ${px2rem(12)};
`;

export const HeaderTextMobile = styled(ContentText)`
  font-size: ${px2rem(18)} !important;
  padding-left: ${px2rem(16)};
`;

export const SidebarLink = styled(SidebarItem)`
  font-family: 'FortumSans', Arial, sans-serif;
`;

export const HeaderContainer = styled(Box)`
  margin-bottom: ${px2rem(4)};
`;

export const HeaderText = styled(ContentText)`
  font-size: ${px2rem(29)} !important;
  @media screen and (max-width: ${breakpoints.mobile}) {
    font-size: ${px2rem(20)} !important;
  }
`;

export const SidebarGroup = styled(SidebarItemGroup)`
  font-family: 'FortumSans', Arial, sans-serif;
`;

export const RightComponentsContainer = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;

export const AuthPopover = styled.div`
  display: flex;
  margin: ${px2rem(24)};
  flex-direction: column;
  row-gap: ${px2rem(32)};
  align-items: center;
`;

export const ActionText = styled(ContentText)`
  color: ${colors.broadBlue700};
  :hover {
    color: #2f507f;
  }
  cursor: pointer;
`;

export const ChangeServiceContainer = styled(Box)`
  display: flex;
  flex-flow: row nowrap;
  column-gap: ${px2rem(16)};
  align-self: flex-start;

  cursor: pointer;
`;

export const RowsDelimiter = styled.div`
  border: 0.5px solid ${colors.silverGrey};
  width: 100%;

  @media screen and (max-width: ${breakpoints.mobile}) {
    display: none;
  }
`;

export const NavSpacer = styled.div`
  @media screen and (max-width: ${breakpoints.large}) {
    margin-bottom: ${px2rem(78)};
  }

  @media screen and (max-width: ${breakpoints.mobile}) {
    margin-bottom: ${px2rem(70)};
  }
`;

export const StyledLogoLink = styled('a')`
  display: inline-flex;
  align-items: center;
  outline: none;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
    text-decoration-color: ${colors.inkGrey};
  }

  svg {
    fill: currentColor;
    color: currentColor;
  }

  &:focus-visible {
    outline: 2px solid ${colors.broadBlue700};
    border-radius: ${px2rem(2)};
  }
`;

export const DesktopLogoLink = styled('a')`
  display: inline-flex;
  align-items: center;
  outline: none;
  text-decoration: none;
  margin-right: 1rem;

  &:hover {
    text-decoration: underline;
    text-decoration-color: ${colors.snowWhite};
  }

  svg {
    fill: ${colors.snowWhite};
    color: ${colors.snowWhite};
  }

  &:focus-visible {
    outline: 2px solid ${colors.snowWhite};
    border-radius: ${px2rem(2)};
  }
`;
